import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  withStyles,
  Grid,
  CardContent,
  TextField,
  InputAdornment,
  Button,
  Typography,
  Snackbar,
  SnackbarContent,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Fade,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
} from '@material-ui/core'
import { AccountCircle, Lock, Error} from '@material-ui/icons'
import { HiChevronDown, HiChevronUp } from 'react-icons/hi'
import lsLogo from '../../assets/lsDirectNEW_Reverse.png'
import sdLogo from '../../assets/SmartDash_copy.png'
import sdLogoReg from '../../assets/SmartDash_darkbg.png'
import backgroundLogo from '../../assets/background-logo.png'
import '../../assets/styles.css'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: '#0c1332',
    },
    '& fieldset': {
      borderColor: '#fff',
      backgroundColor: "transparent",
      borderRadius: 35,
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0c1332',
      backgroundColor: "transparent",
      color: '#fff',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#fff',
    borderRadius: 35,
    backgroundColor: 'transparent',
  }
})

const LoginButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 13,
    width: '65%',
    height: 50,
    border: '2px solid #25aae1',
    borderRadius: "35px",
    color: '#fff',
    margin: '1em',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#10a1da',
      borderColor: '#10a1da',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none'
    },
  }
})(Button)

export default function LandingPage(props) {
  const [state, setState] = useState({username: '', password: ''})
  const [error, setError] = useState(null)
  const [token, setToken] = useState(null)
  const [openSelect, setOpenSelect] = useState(false)
  const [accountsList, setAccountsList] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState("")

  const handleClose = () => {
    if(state.username !== '' || state.password !== '') {
      setError(null)
    }
  }

  const handleChange = (e) => {
    const {name, value} = e.target
    setState(prevState => ({...prevState, [name]: value}))
  }

  const handleKeyPress = (e) => {
    if(e.key === "Enter") {
      handleSubmit()
    }
  }

  const handleSubmit = () => {
    const { username, password } = state
    let data = {
      'username': username,
      'password': password,
    }

    if(data.username === '' || data.password === '') {
      setError('Username and/or Password fields must be filled in')
    } else {
      // fetch('https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/authenticate', {
      fetch(`${base_url}/authenticate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if(response.ok === true) {
          return response.json()
        }
      })
      .then(data => {
        if(data["ACCOUNTS"].length > 1) {
          localStorage.setItem('accounts', JSON.stringify(data["ACCOUNTS"]))
          setOpenSelect(true)
          setAccountsList(data["ACCOUNTS"])
          setToken(data["TOKEN"])
        } else {
          props.handleSuccess(data["TOKEN"])
          props.history.push('/')
        }

      })
      .catch(error => {
        setError('The Username and/or Password you have entered is not recognized')
      console.log(error)
      })
    }
  }

  const handleCloseSelect = () => {
    setOpenSelect(false)
  }

  const handleChangeAccount = (company) => {
    setSelectedAccount(company)
  }

  const handleCancel = () => {
    setOpenSelect(false)
    setSelectedAccount("")
    props.handleLogout()
  }

  const getNewUser = () => {
    const request = fetch(`${base_url}/user`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => {
      localStorage.setItem("currentUser", JSON.stringify(data))
      props.handleSuccess(token)
      props.history.push('/')
    })
    .catch(error => {console.log(error)})
  }

  const handleContinue = () => {
    let selected = accountsList.filter(({companyName}) => companyName === selectedAccount)[0]
    const {ownerID, companyID} = selected

    let data = {
      "o": ownerID,
      "c": companyID,
    }

    if(data.o && data.c) {
      fetch(`${base_url}/authorize`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "token": token
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if(response.ok === true) {
          getNewUser()
        }
      })
      .catch(error => {console.log(error)})
    }
  }

  return (
    <div className="landing-page">
      <Snackbar
        open={error ? true : false}
        autoHideDuration={4500}
        onClose={handleClose}
        anchorOrigin={{vertical: "top", horizontal: "center"}}
      >
        <SnackbarContent
          message={
            <div style={{display: 'flex', color: '#fff'}}>
              <Error className="error" fontSize="small" fontWeight="bold"/>
              <span style={{fontWeight: 600, marginLeft: 15}}>{error}</span>
            </div>
          }
          style={{backgroundColor: '#ba5661'}}
        />
      </Snackbar>
      <LoginComponent
        username={state.username}
        password={state.password}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        onSubmit={handleSubmit}
        error={error}
      />

      <Dialog
        open={openSelect}
        onClose={handleCloseSelect}
        fullWidth={true}
        maxWidth={"sm"}
        className="dialog"
        PaperProps={{
          style: {
            border: "2px solid #25aae1",
            borderRadius: "15px",
            backgroundColor: "#f5f5f5"
          }
        }}
      >
        <DialogTitle style={{backgroundColor: "#25aae1"}}>
          <Typography variant="caption" style={{color: "#fff", fontWeight: "bold", fontSize: "13px"}}>
            Please Choose The Account You Would Like To View
          </Typography>
        </DialogTitle>
        <DialogContent style={{padding: "1em"}}>
          <br/>
          <Select variant="outlined" value={selectedAccount} className="accounts-list-select" size="small">
            {accountsList ? accountsList.map(({companyName}, i) => (
              <MenuItem key={`${companyName}-${i}`} onClick={() => handleChangeAccount(companyName)} value={companyName}>
                <Typography variant="caption">{companyName}</Typography>
              </MenuItem>
            ))
          : null}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button className="dialog-cancel" disableRipple><Typography variant="caption" onClick={handleCancel}>Cancel</Typography></Button>
          <Button className="dialog-confirm-login" disabled={selectedAccount === ""} onClick={handleContinue}><Typography variant="caption">Continue</Typography></Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

const LoginComponent = (props) => {
  const {username, password, onChange, onKeyPress, onSubmit, error, handleOpenMenu, userType, menuAnchor} = props

  return(
    <div className="login-component">
      <Grid
        container
        justify="center"
        alignItems="center"
        direction="column"
        style={{minHeight: '100vh'}}
      >
        <div open={true} className="login">
          <div className="ls-logo"><img style={{width: '45%'}} src={lsLogo} alt="" /></div>
          <CardContent className="content">
            <Grid item className="banner">
              <img className="logo" src={sdLogo} alt="" />
              <Typography variant="caption" style={{fontWeight: 'bold', fontSize: '20px'}}>LOGIN</Typography>
            </Grid>
            <Grid item className="grid">
              <StyledTextField
                name="username"
                type="username"
                className="input"
                placeholder="Username"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccountCircle className="end-adornment" />
                    </InputAdornment>
                  )
                }}
                value={username}
                onChange={onChange}
                onKeyPress={onKeyPress}
                required
                error={error && username.length < 1}
                helperText={error && username.length < 1 ? 'This field cannot be left blank' : null}
              />
            </Grid>
            <Grid item className="grid">
              <StyledTextField
                name="password"
                type="password"
                className="input"
                placeholder="Password"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Lock className="end-adornment" />
                    </InputAdornment>
                  )
                }}
                value={password}
                onChange={onChange}
                onKeyPress={onKeyPress}
                error={error && password.length < 1}
                helperText={error && password.length < 1 ? 'This field cannot be left blank' : null}
                required
              />
            </Grid>
            <Grid item>
              <LoginButton type="submit" onClick={onSubmit} className="login-btn">Login</LoginButton>
            </Grid>
            <div className="copyright">
              <Typography variant="caption">
                2020 © LS Direct
              </Typography>
            </div>
          </CardContent>
        </div>
      </Grid>
    </div>
  )
}
